<form fxLayout="row" fxLayoutAlign="flex-start center" fxLayoutGap="20px" [formGroup]="form">
  <mat-form-field fxFlex="50">
    <mat-label>Nom</mat-label>
    <input type="text" matInput formControlName="nom" [readonly]="saving || isReadOnly" />
  </mat-form-field>

  <mat-form-field fxFlex="50">
    <mat-label>Type</mat-label>
    <mat-select formControlName="idType" [disabled]="isReadOnly">
      <mat-option *ngFor="let type of spTypes" [value]="type.code">
        {{ type.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</form>

<kendo-grid
  #kendoGrid
  [data]="gridWrapper.gridData"
  kendoGridSelectBy="id"
  [selectable]="false"
  [height]="height"
  scrollable="virtual"
  rowHeight="54px"
  [skip]="gridWrapper.gridState.skip"
  [pageSize]="gridWrapper.gridState.take"
  [loading]="gridWrapper.loading"
  [sort]="gridWrapper.gridState.sort || []"
  (dataStateChange)="gridWrapper.onDataStateChange($event)"
  (add)="addHandler($event)"
  (edit)="gridWrapper.editHandler($event)"
  (remove)="removeHandler($event)"
  (cancel)="gridWrapper.cancelHandler($event)"
  (save)="saveHandler($event)"
>
  <ng-template kendoGridToolbarTemplate>
    <div style="width: 100%" fxLayout="row" fxLayoutAlign="space-between center">
      <span style="font-weight: bold; font-size: 16px">Etapes</span>

      <div>
        <input #mainFilter placeholder="Rechercher..." kendoTextBox (input)="gridWrapper.onFilter($event.target)" />
        <button
          color="accent"
          mat-icon-button
          [style.visibility]="mainFilter.value.length > 0 ? 'visible' : 'hidden'"
          (click)="mainFilter.value = ''; gridWrapper.clearFilter()"
        >
          <mat-icon>clear</mat-icon>
        </button>
        <button color="primary" *ngIf="!isReadOnly" [disabled]="saving" mat-icon-button kendoGridAddCommand matTooltip="Ajouter une étape">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>
  </ng-template>

  <kendo-grid-column field="id" title="Ordre" [editable]="false" [columnMenu]="false" [width]="80">
    <ng-template *ngIf="!isReadOnly" kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <div fxLayout="column">
        <mat-icon color="accent" class="clickable" *ngIf="rowIndex > 0" (click)="moveUp(dataItem)"> arrow_drop_up </mat-icon>
        <mat-icon color="accent" class="clickable" *ngIf="rowIndex < gridWrapper.gridData.total - 1" (click)="moveDown(dataItem)">
          arrow_drop_down
        </mat-icon>
      </div>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="nom" title="Nom" [editable]="!isReadOnly">
    <ng-template kendoGridCellTemplate let-dataItem>
      <span class="text-ellipsis" [matTooltip]="dataItem.nom">
        {{ dataItem.nom }}
      </span>
    </ng-template>

    <ng-template kendoGridEditTemplate let-column="column" let-formGroup="formGroup" let-isNew="isNew">
      <mat-form-field class="width-100-pc">
        <mat-label>Nom</mat-label>
        <input type="text" matInput [formControl]="formGroup.get('nom')" />
        <mat-error *ngIf="formGroup.get('nom').hasError('unavailable')">Le numéro PGM existe déjà</mat-error>
      </mat-form-field>      
    </ng-template>
  </kendo-grid-column>

  

  <kendo-grid-column *ngIf="isReadOnly" field="actif" title="Actif" filter="boolean" [width]="130">
    <ng-template kendoGridCellTemplate let-dataItem>
      <mat-icon [style.color]="dataItem.actif ? 'green' : 'yellow'">{{ dataItem.actif ? 'check_circle' : 'pause_circle' }}</mat-icon>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-command-column *ngIf="!isReadOnly" title="Actions" [width]="120">
    <ng-template kendoGridCellTemplate let-formGroup="formGroup" let-dataItem>
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <button color="accent" kendoGridEditCommand mat-icon-button>
          <mat-icon>edit</mat-icon>
        </button>
        <button *ngIf="!dataItem.actif" color="accent" mat-icon-button kendoGridRemoveCommand matTooltip="Supprimer la ligne">
          <mat-icon>delete</mat-icon>
        </button>
        <button color="accent" mat-icon-button kendoGridSaveCommand matTooltip="Confirmer la ligne" [disabled]="formGroup?.invalid">
          <mat-icon>save</mat-icon>
        </button>
        <button color="accent" mat-icon-button kendoGridCancelCommand matTooltip="Annuler l'ajout de la ligne">
          <mat-icon>cancel</mat-icon>
        </button>
      </div>
    </ng-template>
  </kendo-grid-command-column>
</kendo-grid>
